// The "added to cart" event a seller's "Left in carts" panel is built from (pure — no network, so it's unit-testable).
const DEMO_STORE_ID = "bloom-demo-001";   // same id as utils/demo.js DEMO_ID

export function cartEventFor(product, { qty = 1, variation = null, customer = null, storeId = null } = {}) {
  const store_id = product?.user_id || product?._storeInfo?.id || storeId || null;
  if (!store_id || store_id === DEMO_STORE_ID || !product?.id) return null;
  return {
    store_id, product_id: product.id, product_name: product.name || null,
    variation: variation || null, qty: Math.max(1, Number(qty) || 1),
    customer_id: customer?.id || null, customer_name: customer?.name || null,
  };
}
